import { render, staticRenderFns } from "./BelposhtaHead.vue?vue&type=template&id=7b4fa3f8&scoped=true"
import script from "./BelposhtaHead.vue?vue&type=script&lang=js"
export * from "./BelposhtaHead.vue?vue&type=script&lang=js"
import style0 from "./BelposhtaHead.vue?vue&type=style&index=0&id=7b4fa3f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4fa3f8",
  null
  
)

export default component.exports